import React from 'react';
import WithLargeImagesPerson from './WithLargeImagesPerson';

const CustomOrderedTeam = ({ orderArray, blok }) => {
  return (
    <WithLargeImagesPerson customOrderArray={orderArray} blok={blok} />
  );
};

export default CustomOrderedTeam;
